import { createFileRoute } from '@tanstack/react-router';
import { ProfileSettingsPage } from '../components/settings/settings-shell.js';

export const Route = createFileRoute('/$workspaceSlug/settings/profile')({
  component: ProfileSettingsPage,
});
